// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { fermentationEventKindEnum } from './FermentationEventKindEnum';
import { fermentationIncidentCategoryEnum } from './FermentationIncidentCategoryEnum';
import { fermentationIncidentImpactEnum } from './FermentationIncidentImpactEnum';
import { fermentationTimepointId } from './FermentationTimepoint';
import { fermentationInvestigationId } from './FermentationInvestigation';
import { z } from 'zod';
export const fermentationEventId = (z.number());
export const fermentationEvent = z.object({
    id: fermentationEventId,
    fermentation_id: fermentationId.nullable(),
    comment: z.string().nullable(),
    created_at: z.date(),
    operator_id: operatorId.nullable(),
    kind: fermentationEventKindEnum,
    occurred_at: z.date(),
    categories: z.array(fermentationIncidentCategoryEnum),
    impact: fermentationIncidentImpactEnum.nullable(),
    action_taken: z.string().nullable(),
    timepoint_id: fermentationTimepointId.nullable(),
    investigation_id: fermentationInvestigationId.nullable(),
    updated_at: z.date(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationEventInitializer = z.object({
    id: fermentationEventId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    comment: z.string().optional().nullable(),
    created_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    kind: fermentationEventKindEnum.optional(),
    occurred_at: z.date(),
    categories: z.array(fermentationIncidentCategoryEnum).optional(),
    impact: fermentationIncidentImpactEnum.optional().nullable(),
    action_taken: z.string().optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
    investigation_id: fermentationInvestigationId.optional().nullable(),
    updated_at: z.date().optional(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationEventMutator = z.object({
    id: fermentationEventId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    comment: z.string().optional().nullable(),
    created_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    kind: fermentationEventKindEnum.optional(),
    occurred_at: z.date().optional(),
    categories: z.array(fermentationIncidentCategoryEnum).optional(),
    impact: fermentationIncidentImpactEnum.optional().nullable(),
    action_taken: z.string().optional().nullable(),
    timepoint_id: fermentationTimepointId.optional().nullable(),
    investigation_id: fermentationInvestigationId.optional().nullable(),
    updated_at: z.date().optional(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationEvent.js.map